<template>
  <div class="tab-page home-page">
    <div class="type-wrapper">
      <span
        class="pr-20"
        :class="{ active: type === 'pod_capacitance' }"
        @click="selectType('pod_capacitance')"
        v-if="p('Dashboard.Pod Capacitance.View')"
      >
        {{ $t('text.pod_capacitance') }}
      </span>
      <span
        class="pr-20"
        :class="{ active: type === 'pod_accel' }"
        @click="selectType('pod_accel')"
        v-if="p('Dashboard.Pod Accel.View')"
      >
        {{ $t('text.pod_accel') }}
      </span>
      <span
        :class="{ active: type === 'pod_data_stream' }"
        @click="selectType('pod_data_stream')"
        v-if="p('Dashboard.Pod Data Stream.View')"
      >
        pod data stream
      </span>
    </div>
    <div class="home">
      <PodCapacitance
        :latestCaliPodChartDataPoint="latestCaliPodChartDataPoint"
        :countDown="countDown"
        :sensorData="sensorData"
        :latestTime="latestTime"
        v-show="type === 'pod_capacitance'"
        ref="capacitance"
      />
      <PodAccel
        :latestCaliPodChartDataPoint="latestCaliPodChartDataPoint"
        v-show="type === 'pod_accel'"
        ref="accel"
      />
      <PodDataStream v-show="type === 'pod_data_stream'" ref="dataStream" />
    </div>
  </div>
</template>

<script>
import PodCapacitance from '@/components/home/PodCapacitance.vue'
import PodAccel from '@/components/home/PodAccel.vue'
import PodDataStream from '@/components/home/PodDataStream.vue'
// import ApiService from '@/services/ApiService.js'
// import swal from 'sweetalert'
export default {
  data() {
    return {
      type: 'pod_capacitance',
      loading: false,
      latestCaliPodChartDataPoint: {},
      timer: '',
      countDown: 30,
      podLatest30Data: [],
      sensorData: this.initSensorData(),
      latestTime: ''
    }
  },
  mounted() {
    this.type = this.$permission('Dashboard.Pod Capacitance.View')
      ? 'pod_capacitance'
      : this.$permission('Dashboard.Pod Accel.View')
      ? 'accel'
      : 'pod_data_stream'
    this.timer = setInterval(this.getData, 1000)
  },
  components: {
    PodCapacitance,
    PodAccel,
    PodDataStream
  },
  watch: {
    '$store.state.pods.selectedPod': function() {
      clearInterval(this.timer)
      this.countDown = 30
      this.podLatest30Data = []
      this.sensorData = this.initSensorData()
      this.timer = setInterval(this.getData, 1000)
    }
  },
  methods: {
    selectType(type) {
      this.type = type
    },
    initSensorData() {
      return [
        {
          key: this.$t('text.value'),
          sensor1: '--',
          sensor2: '--'
        },
        {
          key: this.$t('text.min'),
          sensor1: '--',
          sensor2: '--'
        },
        {
          key: this.$t('text.max'),
          sensor1: '--',
          sensor2: '--'
        }
      ]
    },
    getData() {
      // We dont't need this anymore
      // if (!this.$store.state.pods.selectedPod.podId) return false
      // this.loading = true
      // ApiService.LatestCaliPodChartDataPoint(
      //   this.$store.state.pods.selectedPod.podId
      // )
      //   .then(response => {
      //     this.loading = false
      //     this.latestCaliPodChartDataPoint = response.data || {}
      //     let vm = this
      //     if (response.data) {
      //       this.$nextTick(() => {
      //         vm.$refs.capacitance.updateChart()
      //         vm.$refs.accel.updateChart()
      //       })
      //     }
      //     // prevent calculate other pod data
      //     if (
      //       response.data &&
      //       response.data.rawData !== this.$store.state.pods.selectedPod.podId
      //     )
      //       return
      //     this.podLatest30Data.push({
      //       sensor1: this.latestCaliPodChartDataPoint.sensor1,
      //       sensor2: this.latestCaliPodChartDataPoint.sensor2,
      //       timeStamp: this.latestCaliPodChartDataPoint.timeStamp
      //     })
      //     this.handleClearLatest30Data()
      //   })
      //   .catch(() => {
      //     this.loading = false
      //     this.handleClearLatest30Data()
      //     swal({
      //       icon: 'error',
      //       timer: 2000,
      //       title: this.$t('text.failed')
      //     })
      //   })
    },
    median(numbers) {
      var median = 0,
        numsLen = numbers.length
      numbers = numbers.sort(function(a, b) {
        return a - b
      })
      if (numsLen % 2 === 0) {
        // is even
        median = (numbers[numsLen / 2 - 1] + numbers[numsLen / 2]) / 2
      } else {
        // is odd
        median = numbers[(numsLen - 1) / 2]
      }
      return median
    },
    //Once it goes to 0 you need to calculate median and min and max value from that 30 data points
    handleClearLatest30Data() {
      this.countDown--
      if (this.countDown <= 0) {
        let latest30Sensor1 = this.podLatest30Data
          .map(item => {
            return item.sensor1
          })
          .filter(item => {
            return typeof item !== 'undefined'
          })
        let latest30Sensor2 = this.podLatest30Data
          .map(item => {
            return item.sensor2
          })
          .filter(item => {
            return typeof item !== 'undefined'
          })
        let latestTimes = this.podLatest30Data
          .map(item => {
            return item.timeStamp
          })
          .filter(item => {
            return typeof item !== 'undefined'
          })
        this.latestTime = latestTimes[latestTimes.length - 1]
        this.$set(this.sensorData, 0, {
          key: this.$t('text.value'),
          sensor1: latest30Sensor1.length ? this.median(latest30Sensor1) : '--',
          sensor2: latest30Sensor2.length ? this.median(latest30Sensor2) : '--'
        })
        this.$set(this.sensorData, 1, {
          key: this.$t('text.min'),
          sensor1: latest30Sensor1.length ? Math.min(...latest30Sensor1) : '--',
          sensor2: latest30Sensor2.length ? Math.min(...latest30Sensor2) : '--'
        })
        this.$set(this.sensorData, 2, {
          key: this.$t('text.max'),
          sensor1: latest30Sensor1.length ? Math.max(...latest30Sensor1) : '--',
          sensor2: latest30Sensor2.length ? Math.max(...latest30Sensor2) : '--'
        })
        this.countDown = 30
        this.podLatest30Data = []
      }
    }
  },
  beforeDestroy() {
    clearInterval(this.timer)
  }
}
</script>
